import { z } from "zod";

// Password should be at least 8 characters long and include special characters
export const PasswordSchema = z.string().regex(/^(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/, {
  message: "Password should be at least 8 characters long and include special characters",
});
